<template>
    <div class="exam-list">
        <manage-title>考试列表</manage-title>
        <div class="form">
            <el-form :inline="true">
                <el-form-item>
                    <medical-class-selector
                        v-model="form.category"
                        @change="loadData(true)"
                    ></medical-class-selector>
                </el-form-item>
                <el-form-item>
                    <el-select
                        v-model="form.enable"
                        placeholder="启用 / 禁用"
                        clearable
                        @change="loadData(true)"
                        style="width:150px"
                    >
                        <el-option
                            v-for="item in enableArr"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select
                        v-model="form.use"
                        placeholder="用途"
                        clearable
                        @change="loadData(true)"
                        style="width:150px"
                    >
                        <el-option
                            v-for="item in useArr"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select
                        v-model="form.examTimeState"
                        placeholder="考试状态"
                        clearable
                        @change="loadData(true)"
                        style="width:150px"
                    >
                        <el-option
                            v-for="item in statesArr"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input
                        placeholder="请输入关键字检索..."
                        v-model="form.examName"
                        @change="loadData(true)"
                        style="width:250px;margin:0 -25px 0 0;"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button
                        type="primary"
                        class="ml-10"
                        @click="loadData(true)"
                        >检索</el-button
                    >
                </el-form-item>
            </el-form>
            <div class="xy-between">
                <div>
                    <el-button
                        v-if="$store.state.isCheckEnd"
                        type="primary"
                        @click="$router.push({ name: 'create-exam' })"
                        >新增</el-button
                    >
                    <el-button
                        v-if="$store.state.isCheckEnd"
                        type="success"
                        v-loading="changeIng"
                        @click="changeState(selectList, 2)"
                        >启用</el-button
                    >
                    <el-button
                        type="danger"
                        v-loading="changeIng"
                        @click="changeState(selectList, 1)"
                        >禁用</el-button
                    >
                </div>
                <!-- <div class="xy-start">
                    <el-input
                        placeholder="请输入关键字检索"
                        v-model="form.examName"
                        @change="loadData(true)"
                    ></el-input>
                    <el-button
                        type="primary"
                        class="ml-10"
                        @click="loadData(true)"
                        >检索</el-button
                    >
                </div> -->
            </div>
        </div>
        <div class="form" v-loading="loading">
            <el-table
                :data="list"
                @selection-change="(list) => (selectList = list)"
                style="width: 100%"
            >
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column label="考试名称" prop="ExamName" width="200" />
                <el-table-column
                    label="试卷名称"
                    width="150"
                >
                    <template slot-scope="scope">
                        <el-popover trigger="hover" placement="top">
                            <p>{{ scope.row.PaperName }}</p>
                            <div slot="reference" class="name-wrapper">
                             <p style=" width: 0.4rem;
                                        text-overflow: ellipsis;
                                        overflow: hidden;
                                        white-space: nowrap;">
                                 {{ scope.row.PaperName }}</p>
                            </div>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column
                    label="开始时间"
                    prop="BeginTime"
                    width="160"
                    :formatter="timeNoSec"
                />
                <el-table-column
                    label="结束时间"
                    prop="EndTime"
                    width="160"
                    :formatter="timeNoSec"
                />
                <el-table-column label="分类" prop="ClassName" width="80" />
                <el-table-column label="考试状态" prop="status" width="80" />
                <el-table-column label="启用/禁用" width="90">
                    <template v-slot="scope">
                        <span v-if="scope.row.ExamState === 2">启用</span>
                        <span v-if="scope.row.ExamState === 1">禁用</span>
                    </template>
                </el-table-column>
                <el-table-column label="类型" width="90">
                    <template v-slot="scope">
                        <span v-if="scope.row.ExamType === 1">考试</span>
                        <span v-if="scope.row.ExamType === 2">作业</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="参考人员"
                    prop="GroupName"
                    width="150"
                    show-overflow-tooltip
                />
                <el-table-column
                    label="创建人"
                    prop="AddUserName"
                    width="120"
                />
                <el-table-column
                    label="创建时间"
                    prop="AddTime"
                    width="160"
                    :formatter="timeNoSec"
                />
                <el-table-column label="操作" fixed="right" width="240">
                    <div
                        slot-scope="scope"
                        class="xy-center flex-wrap operation"
                    >
                        <el-button size="mini" @click="preview(scope.row)"
                            >预览</el-button
                        >
                        <el-button
                            size="mini"
                            @click="openQrcode(scope.row)"
                            :disabled="scope.row.ExamState === 1"
                            >二维码</el-button
                        >
                        <el-button size="mini" v-if="$store.state.isCheckEnd" @click="editRow(scope.row)"
                            >{{scope.row.status === '已结束' ? '复制' : '编辑'}}</el-button
                        >
                        <el-popconfirm
                            title="你确定要删除该考试吗？"
                            @confirm="changeState(scope.row, -1)"
                            style="margin-right: 10px"
                        >
                            <el-button
                                type="danger"
                                size="mini"
                                slot="reference"
                                >删除</el-button
                            >
                        </el-popconfirm>
                        <el-button
                            v-if="scope.row.ExamState === 1&& $store.state.isCheckEnd"
                            type="success"
                            size="mini"
                            @click="changeState(scope.row, 2)"
                            >启用</el-button
                        >
                        <el-button
                            v-else
                            type="danger"
                            size="mini"
                            @click="changeState(scope.row, 1)"
                            >禁用</el-button
                        >
                    </div>
                </el-table-column>
            </el-table>
        </div>
        <div class="xy-center mt-17 mb-10">
            <el-pagination
                @current-change="loadData()"
                @size-change="loadData(true)"
                :current-page.sync="form.pageNo"
                :page-size.sync="form.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                hide-on-single-page
                :total="form.total"
            >
            </el-pagination>
        </div>

        <!-- 二维码弹窗 -->
        <el-dialog
            :visible.sync="qrcode.show"
            title="考场二维码"
            :lock-scroll="false"
            custom-class="m-dialog"
            width="500px"
        >
            <div class="xy-center">
                <div id="qr-code" style="width: 128px;height: 128px"></div>
                <div class="info">
                    <div class="font-medium" style="margin-bottom: 20px">
                        考场名称：{{ qrcode.data.ExamName }}
                    </div>
                    <div>说明：二维码可以用于移动端在线考试</div>
                    <div>
                        <span class="font-medium">广域网二维码</span
                        >：支持任何外网IP段扫码
                    </div>
                </div>
            </div>
            <span slot="footer">
                <el-button @click="qrcode.show = false" type="primary"
                    >关闭</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>

<script>
import MedicalClassSelector from "@/components/manager/MedicalClassSelector";
import ManageTitle from "@/components/manager/ManageTitle";
import { examGetList, updateExamState } from "@/api/manage";
import { isEmpty } from "lodash";
import tableFormatter from "@/mixins/tableFormatter";
import QRCode from "qrcodejs2";
import {examLinkName} from "@/views/manage/exam/exam-link";

export default {
    name: "ExamList",
    mixins: [tableFormatter],
    components: { ManageTitle, MedicalClassSelector },
    data() {
        return {
            form: {
                category: "",
                enable: "",
                use: "",
                examTimeState: "",
                examName: "",
                pageNo: 1,
                pageSize: 10,
                total: 1000
            },
            loading: false,
            changeIng: false,
            list: [],
            qrcode: {
                show: false,
                data: {}
            },
            selectList: []
        };
    },
    created() {
        this.loadData();
    },
    computed: {
        enableArr() {
            return [
                { value: "2", label: "启用" },
                { value: "1", label: "禁用" }
            ];
        },
        useArr() {
            return [
                { value: "1", label: "考试" },
                { value: "2", label: "作业" }
            ];
        },
        statesArr() {
            return [
                { value: "1", label: "未开始" },
                { value: "2", label: "考试中" },
                { value: "3", label: "已结束" }
            ];
        }
    },
    methods: {
        async loadData(refresh) {
            if (refresh) {
                this.form.pageNo = 1;
            }
            let query = {
                classId: this.form.category,
                pageNo: this.form.pageNo,
                pageSize: this.form.pageSize
            };
            if (this.form.examName) query.examName = this.form.examName;
            if (this.form.examTimeState) {
                query.examTimeState = this.form.examTimeState;
            }
            if (this.form.use) query.examType = this.form.use;
            if (this.form.enable) query.examState = this.form.enable;
            if (query.classId === "1000") delete query.classId;
            try {
                this.loading = true;
                let { data } = await examGetList(query);
                this.form.total = data.count;

                data.data.forEach((item) => {
                    let now = new Date().getTime();
                    let date1 = new Date(item.BeginTime.replace(/-/g, "/"));
                    let date2 = new Date(item.EndTime.replace(/-/g, "/"));
                    date1 = date1.getTime();
                    date2 = date2.getTime();
                    // 判断当前考试的状态
                    if (
                        parseInt(now) > parseInt(date1) &&
                        parseInt(now) < parseInt(date2)
                    ) {
                        item.status = "考试中"; // 考试中
                    } else if (parseInt(now) < parseInt(date1)) {
                        item.status = "未开始"; // 未开始
                    } else {
                        item.status = "已结束"; // 已结束
                    }
                });
                this.list = data.data;
            } finally {
                this.loading = false;
            }
        },
        async openQrcode(item) {
            this.qrcode.data = item;
            this.qrcode.show = true;
            // 如果是本地链接测试，则不加.html，否则要加上，他们IIS部署不支持自动识别.html
            let path = location.hostname.startsWith("192") ? "/mobile-exam" : "/mobile-exam.html"
            const pathname = location.pathname.endsWith("/") ? location.pathname.slice(0, -1) : location.pathname;
            let text = location.origin + pathname + `${path}#/${examLinkName}?`;
            let title = "医学培训考试服务平台"
            const userInfo = this.$store.state.userInfo
            if (Object.isObj(userInfo) && userInfo) {
                title = userInfo.PlatformName
            }
            text += `examId=${item.ExamId}&documentTitle=${title}`;

            console.log("exam qrcode: ", text)
            this.$nextTick(() => {
                let qr = document.getElementById("qr-code");
                qr.innerText = "";
                let qrcode = new QRCode(qr, {
                    text: text,
                    width: 128,
                    height: 128,
                    colorDark: "#000000",
                    colorLight: "#ffffff",
                    correctLevel: QRCode.CorrectLevel.H
                });
            });
        },
        editRow(item) {
            this.$router.push({
                name: "create-exam",
                query: { id: item.ExamId }
            });
        },
        preview(item) {
            let { href } = this.$router.resolve({
                name: "previewExam",
                query: {
                    id: item.ExamId,
                    paperId: item.ExamPaperId,
                    ExamName: item.ExamName
                }
            });
            console.log("open preview: ", href)
            window.open(href, "_blank");
        },
        /**
         * 改变考试状态
         * @param exam 考试或者考试列表
         * @param state 2启用，1禁用,-1删除
         */
        changeState(exam, state) {
            let list;
            if (exam instanceof Array) {
                list = exam;
            } else {
                list = [exam];
            }
            if (isEmpty(exam)) {
                this.$message("请选择要操作的考试");
                return;
            }
            let ids = list.map((el) => el.ExamId).join(",");
            this.changeIng = true;
            updateExamState({ ids, state })
                .then((data) => {
                    if (state === -1) {
                        this.loadData(true);
                    } else {
                        list.forEach((el) => {
                            el.ExamState = state;
                        });
                    }
                    this.$message.success("操作成功");
                })
                .finally(() => {
                    this.changeIng = false;
                });
        }
    }
};
</script>

<style scoped lang="less">
.form {
    padding: 20px;
}

.exam-list {
    width: 100%;

    ::v-deep.operation {
        button {
            margin-top: 10px;
        }
    }

    .info {
        margin-left: 30px;
    }
}
</style>
